import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';

export class Media extends Model {
  @Expose() id: number = null;
  @Expose() url: string = '';
  @Expose() downloadUrl: string = '';
  @Expose() mimetype: string = '';
  @Expose() type: string = '';
  @Expose() createdAt: number;
  @Expose() updatedAt: number;

  constructor() {
    super();
  }
}
